export default __webpack_public_path__ + "static/awbi-620c6963a920c91bdf371a6d85260704.png";